import React, { useState, useEffect } from 'react'
import { Layer, Button, Logo } from "components"
import useApp from 'hooks/useApp'
import { useRecoilValue, useRecoilState } from 'recoil'
import { best50CountState, bestCheckedCountState, checkedCountState } from 'views/data/states.js'
import { orgListState, showBest50LayerState } from '../states'

const Best50Layer = ({ setCheck }) => {

	const App = useApp()
	const [allCheck, setAllCheck] = useState(false)
	const best50Count = useRecoilValue(best50CountState)
	const [data, setData] = useRecoilState(orgListState()) // 기관목록 데이터
	const [showLayer, setShowLayer] = useRecoilState(showBest50LayerState)

	const bestCheckedCount = useRecoilValue(bestCheckedCountState)
	const checkedCount = useRecoilValue(checkedCountState)

	const checkAll = () => {
		if(checkedCount + best50Count > 50 && !allCheck) {
			App.toast("기관선택은 한번에 50개까지만 가능해요.");
			return null;
		}

		const allChecked = (allCheck => {
			const newData = data.map(group => {
				let groupCheckedCount = 0
				const data = group.data.map(item => {
					let checked = item.checked
					if (item.best50 === true) {
						checked = !allCheck
					}
					if (checked) groupCheckedCount++
					return {
						...item,
						checked: checked
					}
				})
				return {
					...group,
					checkedCount: groupCheckedCount,
					data: data
				}
			})
			setData(newData)
			return !allCheck
		})
		setAllCheck(allChecked)
	}

	useEffect(() => {
		if (!data) return
		let count = 0, allCount = 0, ncount = 0
		data.forEach(group => {
			group.data.forEach(item => {
				if (item.best50 === true) {
					allCount++
					if (item.checked === true) {
						count++
					}
				}
				if (item.checked === true) {
					ncount++
				}
			})
		})
		if (count === allCount) {
			setAllCheck(true)
		} else {
			setAllCheck(false)
		}
	}, [data])

	// console.log("전체 업권별 목록 및 베스트50 목록(DB id=lstInsttInf 와 best50 일치한 것)", data)

	return (
		<Layer show={showLayer} closeLayer={() => setShowLayer(false)} title="BEST">
			<div className={`padding best50Layer pb_80`}>
				<div className="data_count-group__1hloi py_20"><p>고객들이 많이 연결하는 BEST 목록</p></div>
				<div className="chk text-align_right" onClick={checkAll}>
					<i className={`mr_10 checkMark ${allCheck === true ? "on" : ""}`} />
					<label htmlFor="checkAll">
						<span style={{ color: "#333" }}>전체선택</span>
					</label>
				</div>
				<ul className="check-area mt_10">
					{
						data &&
						data.map((group, index) => {
							return (
								<React.Fragment key={index}>
									{
										group.bestCount > 0 &&
										<>
											<li className="check-title">{group.indstNm}<span className="ml_5">{group.bestCount}</span></li>
											<li>
												{
													group.data.map((item, index) => {
														if (item.best50 === true) {
															return (
																<div key={index} className={`check-list ${item.checked ? "on" : ""}`} onClick={() => setCheck(item.insttCd)}>
																	<div>
																		<div className="ellipsis">
																			<div className="img-box img-symbol">
																				<Logo code={item.insttCd} style={{ width: "100%", height: "100%" }} />
																			</div>
																			<p className="ml_10 ellipsis" style={{ width: "17rem" }}>{item.insttNm}</p>
																		</div>
																	</div>
																</div>
															)
														}
													})
												}
											</li>
										</>
									}
								</React.Fragment>
							)
						})
					}
				</ul>
			</div>
			<div className="button-group">
				<Button className="btn btn--big btn-layer fixed" onClick={() => setShowLayer(false)} style={{ bottom: 0 }}>적용하기 <strong>({bestCheckedCount})</strong></Button>
			</div>
		</Layer>
	)
}

export default Best50Layer